<div>
    <div [ngBusy]="{busy: busy, backdrop: true, message: 'Processing', minDuration: 600}"></div>
    @if (isReferenceDataLoaded()) {
        <div>
            <router-outlet></router-outlet>
            <notification-alerts></notification-alerts>
        </div>
    }
</div>
